import Header from '../Component/Header'
import Footer from '../Component/Footer'
import Breadcrumb from '../Component/Breadcrumb'
const OurPrincipals = () => {
    return (
        <>
            <Header />
            <Breadcrumb title="Our Principals" midBreadcrumb="Office Bearers" mainBreadcrumb="Our Principals" ></Breadcrumb>
            <div className='inner-page'>
                <div class="container">
                    <div class="row uniform">
                        <div class="col-12">
                            <h2 class="mainhead" >Our Principals</h2>
                            <div class="auto-container">
                                <div class="row clearfix r-4">
                                    {/* <div class="team-block col-lg-4 col-md-6 col-sm-12" >
                                        <div class="inner-box">
                                            <div class="image">
                                                <a href="#"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/principal-25.jpg"
                                                    alt="matamariamjansevavidyalayas" /></a>
                                            </div>
                                            <div class="lower-content">
                                                <h3><a href="#">-</a></h3>
                                                <div class="designation">2025 to Till Now</div>
                                            </div>
                                        </div>
                                    </div> */}

                                    <div class="team-block col-lg-4 col-md-6 col-sm-12" >
                                        <div class="inner-box">
                                            <div class="image">
                                                <a href="#"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/JohnMarcus.jpg"
                                                    alt="matamariamjansevavidyalayas" /></a>
                                            </div>
                                            <div class="lower-content">
                                                <h3><a href="#">Rev. Fr. John Marcus Fernandes SFX</a></h3>
                                                <div class="designation">2022 Till Now </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="team-block col-lg-4 col-md-6 col-sm-12" >
                                        <div class="inner-box">
                                            <div class="image">
                                                <a href="#"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/principal-1.png"
                                                    alt="matamariamjansevavidyalayas" /></a>
                                            </div>
                                            <div class="lower-content">
                                                <h3><a href="#">Fr. Eulalio Julio Fernandes</a></h3>
                                                <div class="designation">2019 to 2022</div>
                                            </div> 
                                        </div>
                                    </div>
                                    <div class="team-block col-lg-4 col-md-6 col-sm-12" >
                                        <div class="inner-box">
                                            <div class="image">
                                                <a href="#"><img
                                                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/sfxprincipal.png"
                                                    alt="matamariamjansevavidyalayas" /></a>
                                            </div>
                                            <div class="lower-content">
                                                <h3><a href="#">Rev. Fr. Maria Michael SFX</a></h3>
                                                <div class="designation">2014 to 2019</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="team-block col-lg-4 col-md-6 col-sm-12" >
                                        <div class="inner-box">
                                            <div class="image">
                                                <a href="#"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/JohnMarcus.jpg"
                                                    alt="matamariamjansevavidyalayas" /></a>
                                            </div>
                                            <div class="lower-content">
                                                <h3><a href="#">Rev. Fr. John Marcus Fernandes SFX</a></h3>
                                                <div class="designation">2010 to 2014</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default OurPrincipals